// import '@ant-design/compatible/assets/index.css';


import { useQuery } from 'react-query';
import React, { useEffect, useMemo, useState } from 'react';

import { Spin, Row, Card, Col, DatePicker, Divider, Switch } from 'antd';
import DF from 'DisplayFramework';
import { toCurrency } from 'utils/utils';

import Form, { FormInstance } from 'antd/lib/form';

import { isNil } from 'lodash';
import { dateToString, toDatePickerDate } from 'utils/utils2';
import { useForm } from 'antd/lib/form/Form';
import GetLabel from 'DisplayFramework/components/GetLabel';
import FormInput from 'components/FormInput';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import { AssetDepreciationValues, AssetFutureValues } from 'services/assets';
import { getAssetValues, GetAssetValuesParams } from 'services/finassets';
import moment from 'moment';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataTable/DataTable';
import TextArea from 'antd/lib/input/TextArea';
import InputCurrency from 'components/InputCurrency';
import ParListSelect from 'components/ParListSelect';

export type TabAddmarketvalueProps = {
  objectid: number;
  form: FormInstance;
  setSuccessful: any;
};

const TabAddmarketvalue = ({
  objectid,
  form: formW,
  setSuccessful,
}: TabAddmarketvalueProps) => {
  const [form] = useForm();

  const [searchParams, setSearchParams] = useState<GetAssetValuesParams>({
    assetid: objectid,
    valuedate: moment().format('YYYY-MM-DD'),
  });

  const { data: assetValues, isFetching } = useQuery(
    ['getAssetValues', searchParams],
    () => getAssetValues(searchParams).then((res) => res.data || []),
    {
      enabled: !isNil(objectid),
    }
  );

  useEffect(() => {
    setSuccessful(isFetching);
  }, [isFetching]);

  useEffect(() => {
    if (assetValues) {
      form.setFieldsValue({
        ...assetValues,
      });
    }
    formW.setFieldsValue({ event: 'tabAddmarketvalue', flagupdatefv: false });
  }, [form, assetValues]);

  const columnsfv = useMemo<DataGridColDef<AssetFutureValues>[]>(
    () => [
      {
        dataIndex: 'contextcodelabel',
        width: 150,
      },
      {
        dataIndex: 'fvtypelabel',
        width: 150,
      },
      {
        dataIndex: 'fvamount',
        width: 150,
        render: (val) => toCurrency(val, assetValues?.currcode??localStorage.getItem('currcode') ?? ''),
      },
    ],
    []
  );
  const columnsDepr = useMemo<DataGridColDef<AssetDepreciationValues>[]>(
    () => [
      {
        dataIndex: 'deprcontextlabel',
        width: 150,
      },
      {
        dataIndex: 'deprmethodlabel',
        width: 150,
      },
      {
        dataIndex: 'assetvaluedate',
        width: 150,
      },
      {
        dataIndex: 'assetvalueamount',
        width: 150,
        render: (val) => toCurrency(val, assetValues?.currcode??localStorage.getItem('currcode') ?? ''),
      },
    ],
    []
  );

  return (
    <DF.Provider pagcode="tabAddmarketvalue">
      <Form
        form={form}
        onValuesChange={(val) => {
          if (val.valueamount)
            formW?.setFieldsValue({ valueamount: val.valueamount });

          if (val.mvsource) formW?.setFieldsValue({ mvsource: val.mvsource });

          if (val.comment) formW?.setFieldsValue({ comment: val.comment });

          if (val.flagupdatefv)
            formW?.setFieldsValue({ flagupdatefv: val.flagupdatefv });
          if (val.startdate)
            formW?.setFieldsValue({ startdate: val.startdate });
        }}
        layout="horizontal"
      >
        <Spin spinning={isFetching}>
          <Row>
            <Col span={8}>
              <strong>
                <GetLabel label="Pleaseenteranevaluationdate:" />
                &nbsp;
                <DatePicker
                  defaultValue={
                    toDatePickerDate(searchParams.valuedate) as moment.Moment
                  }
                  onChange={(date) => {
                    setSearchParams({
                      ...searchParams,
                      valuedate: dateToString(date),
                    });
                  }}
                />
              </strong>
            </Col>
          </Row>
          <br />
          <Row>
            <UtinaCard
              level={5}
              comcode="info1"
              style={{ color: '#000', marginLeft: 30 }}
              lg={12}
            >
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="statuslabel"
                  comcode="statuslabel"
                >
                  <Value />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetstatusdate"
                  comcode="assetstatusdate"
                >
                  <Value />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="deliverydate"
                  comcode="deliverydate"
                >
                  <Value />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetnetamount"
                  comcode="assetnetamount"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetfinamount"
                  comcode="assetfinamount"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetrvamount"
                  comcode="assetrvamount"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>
              </Row>
            </UtinaCard>
            <UtinaCard
              level={5}
              comcode="info2"
              style={{ color: '#000', marginLeft: 30 }}
              lg={11}
            >
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetfinrvamount"
                  comcode="assetfinrvamount"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetvaluesdate"
                  comcode="assetvaluesdate"
                >
                  <Value />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="assetirvamount"
                  comcode="assetirvamount"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvalue"
                  comcode="marketvalue"
                >
                  <Value formatter={(value) => toCurrency(value, assetValues?.currcode??localStorage.getItem('currcode') ?? '')} />
                </FormInput>
              </Row>
              <Row gutter={16}>
                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvaluedate"
                  comcode="marketvaluedate"
                >
                  <Value />
                </FormInput>

                <FormInput
                  col
                  xs={24}
                  md={12}
                  name="marketvalueorigin"
                  comcode="marketvalueorigin"
                >
                  <Value />
                </FormInput>
              </Row>
            </UtinaCard>
          </Row>
          <Row>
            <UtinaCard
              level={5}
              comcode="FuturesValues"
              style={{ color: '#000', marginLeft: 30 }}
              lg={10}
            >
              <DataGrid
                columns={columnsfv}
                dataSource={assetValues?.futureValues}
                pagination={false}
                rowKey="contextid"
                size="small"
                hideFilters
                bordered
              />
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="Depreciation"
              style={{ color: '#000', marginLeft: 30 }}
              lg={13}
            >
              <DataGrid
                columns={columnsDepr}
                dataSource={assetValues?.depreciationValues}
                pagination={false}
                rowKey="contextid"
                size="small"
                hideFilters
                bordered
              />
            </UtinaCard>
          </Row>
          <Divider>
            <GetLabel label="newMarketValues:" />
          </Divider>
          <Card type="inner">
            <Row gutter={32}>
              <Col span={12}>
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="valueamount"
                    comcode="valueamount"
                  >
                    <InputCurrency currcode={assetValues?.currcode??localStorage.getItem('currcode') ?? ''} />
                  </FormInput>
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="mvsource"
                    comcode="mvsource"
                  >
                    <ParListSelect parcode="MVSOURCE" />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={24}
                    md={12}
                    name="startdate"
                    comcode="startdate"
                  >
                    <DatePicker />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <FormInput
                    col
                    xs={24}
                    md={6}
                    name="flagupdatefv"
                    comcode="flagupdatefv"
                    initialValue={false}
                    valuePropName="checked"
                  >
                    <Switch />
                  </FormInput>
                </Row>
              </Col>
              <Col span={12}>
                <FormInput name="comment" rules={[{ required: true }]}>
                  <TextArea maxLength={255} rows={5} cols={300} />
                </FormInput>
              </Col>
            </Row>
          </Card>
        </Spin>
      </Form>
    </DF.Provider>
  );
};
export default TabAddmarketvalue;
